import { getAppPath } from "constants/path"
let propertyId = localStorage.getItem("propertyId")
let userEmail = localStorage.getItem("userEmail")

export const setProperty = (property, preventReload) => {
  propertyId = property.id;
  localStorage.setItem("propertyId", propertyId);
  localStorage.setItem("userEmail", property.userEmail)
  localStorage.setItem("userRole", property.userRole)
  if (preventReload) return
  window.location.replace(getAppPath(propertyId));
}

export const getUserEmail = () => {
  return userEmail
}

export const getPropertyId = (ifAppStart) => {
  if (ifAppStart) {
    if (window.location.pathname.split("/")[1]) {
      return window.location.pathname.split("/")[1]
    } else {
      return propertyId || window.location.pathname.split("/")[1]
    }
  } else {
    return window.location.pathname.split("/")[1] || propertyId
  }
}

export const getDrawerState = () => {
  if (localStorage.getItem("drawer") === "false") return false;
  return true;
}

export const getUserRole = () => {
  return localStorage.getItem("userRole")
}

export const getBanner = (key) => {
  if (localStorage.getItem(key) === "false") return false;
  return true;
};

export const setBanner = (key) => {
  return localStorage.setItem(key, "false");
};

export const getEventFilters = () => {
  return [
    {
      label: 'Draft',
      selectedColor: '#333',
      value: 'draft'
    },
    {
      label: 'To Be Approved',
      selectedColor: '#EDB526',
      value: 'to_be_approved'
    },
    {
      label: 'Scheduled For Publish',
      selectedColor: '#8757D6',
      value: 'publish_scheduled'
    },
    {
      label: 'Published',
      selectedColor: '#0BD3BB',
      value: 'published'
    },
    {
      label: 'Scheduled For Invite',
      selectedColor: '#3F7DDA',
      value: 'invite_scheduled'
    },
    {
      label: 'Invited',
      selectedColor: '#66D184',
      value: 'invited'
    },
    {
      label: 'Canceled',
      selectedColor: '#999999',
      value: 'canceled'
    },
    {
      label: 'Archived',
      selectedColor: '#98673A',
      value: 'archived'
    }
  ];
};

export const shouldDoApprove = (event) => {
  let needToApprove = localStorage.getItem("my_approver_requests");
  if (needToApprove) needToApprove = needToApprove.split(",");
  else return false;
  return (event.status === "to_be_approved" && needToApprove.indexOf(event.id) > -1)
}


export const setPropertyIdLocalStorage = (propertyId) => {
  localStorage.setItem("propertyId", propertyId);
};

export const premiumApps = ["hyBlast", "hyALM", "hyRaf", "hyEvents"];

export const globalTohyMail = {
  hyBlast: {
    name: "Blasts",
    url: "blast",
  },
  hyALM: {
    name: "Drips",
    url: "drips",
  },
  hyRaf: {
    name: "Raf",
    url: "hyraf",
  },
  hyEvents: {
    name: "Events",
    url: "events",
  },
};